module.exports = __webpack_public_path__ + "media/assets/CurvedArrow-427a7010d86294f80914f77527768a96.svg";